var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 21.0942H8.25004C3.27254 21.0942 1.14587 18.9675 1.14587 13.99V8.48998C1.14587 3.51249 3.27254 1.38582 8.25004 1.38582H13.75C18.7275 1.38582 20.8542 3.51249 20.8542 8.48998V13.99C20.8542 18.9675 18.7275 21.0942 13.75 21.0942ZM8.25004 2.76082C4.02421 2.76082 2.52087 4.26415 2.52087 8.48998V13.99C2.52087 18.2158 4.02421 19.7192 8.25004 19.7192H13.75C17.9759 19.7192 19.4792 18.2158 19.4792 13.99V8.48998C19.4792 4.26415 17.9759 2.76082 13.75 2.76082H8.25004Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16663 21.0942C8.79079 21.0942 8.47913 20.7825 8.47913 20.4067V2.07332C8.47913 1.69749 8.79079 1.38582 9.16663 1.38582C9.54246 1.38582 9.85413 1.69749 9.85413 2.07332V20.4067C9.85413 20.7825 9.54246 21.0942 9.16663 21.0942Z",
    fill: "#98A2B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1666 11.9275H9.16663C8.79079 11.9275 8.47913 11.6158 8.47913 11.24C8.47913 10.8642 8.79079 10.5525 9.16663 10.5525H20.1666C20.5425 10.5525 20.8541 10.8642 20.8541 11.24C20.8541 11.6158 20.5425 11.9275 20.1666 11.9275Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIcon);
export default __webpack_public_path__ + "static/media/templateIcon.04dd444625922f82ac9a06db579f553c.svg";
export { ForwardRef as ReactComponent };